var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlexishr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.78 17.7514L14.58 13.0282C14.34 11.9718 14.04 10.7288 13.14 9.98305C13.02 9.85876 12.84 9.79661 12.72 9.67232C12.54 9.61017 12.42 9.48588 12.24 9.48588C12.06 9.42373 11.88 9.36158 11.76 9.36158C11.58 9.36158 11.4 9.29943 11.22 9.29943C10.38 9.29943 9.6 9.67232 9 10.2316C8.46 10.791 8.1 11.5989 8.1 12.5311C8.1 13.4633 8.46 14.209 9 14.8305C9.54 15.3898 10.32 15.7627 11.22 15.7627C11.7 15.7627 12.12 15.6384 12.54 15.452C12.84 15.3277 13.14 15.0791 13.38 14.8305L13.98 17.1921C13.8 17.3164 13.62 17.3785 13.44 17.5028C12.78 17.8136 12 18 11.22 18C9.78 18 8.46 17.3785 7.5 16.3842C6.6 15.452 6 14.0847 6 12.5311C6 10.9774 6.6 9.61017 7.56 8.61582C8.52 7.62147 9.84 7 11.28 7C11.58 7 11.88 7 12.18 7.06215C12.48 7.12429 12.78 7.18644 13.02 7.31073C13.32 7.43503 13.56 7.55932 13.8 7.68362C14.04 7.80791 14.28 7.99435 14.52 8.18079C15.24 8.74011 15.72 9.48588 16.02 10.2938C16.32 10.9774 16.5 11.7232 16.68 12.4689L18 17.7514H15.78Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexishr);
export default __webpack_public_path__ + "static/media/alexishr.9b211b319a3d84d3306ec8b3603c30eb.svg";
export { ForwardRef as ReactComponent };